import { Stack } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

import { Breadcrumbs } from "@/components/Breadcrumbs";
import { getDocumentTitle, useRequireParams } from "@/utils";

import { TrainingDetail } from "./TrainingDetail";

export function MemberTrainingDetailPage() {
  const location = useLocation();
  const path = location?.pathname ?? "";
  const isAnother = path.includes("another");
  const memberPath = isAnother ? "/members/another" : "/members";

  const { memberId, trainingId } = useRequireParams(["memberId", "trainingId"]);

  const title = "รายละเอียดเป้าหมายการเทรน";

  const breadcrumbs = {
    items: [
      { label: "สมาชิก", to: "/members" },
      { label: isAnother ? "สมาชิกอื่นๆ" : "สมาชิกที่ดูแล", to: memberPath },
      { label: "ช้อมูลสมาชิก", to: `${memberPath}/${memberId}` },
      { label: title, to: `${memberPath}/${memberId}/trainings/${trainingId}` },
    ],
  };

  return (
    <Stack gap={4}>
      <Helmet>
        <title>{getDocumentTitle(title)}</title>
      </Helmet>
      <Breadcrumbs {...breadcrumbs} />
      <TrainingDetail id={trainingId} />
    </Stack>
  );
}
